/* eslint-disable max-len */
import React from 'react';
import Loader from '../Loader';
import { motion } from "framer-motion";

const UpdateButton = ({ButtonName, loading, handleOnCLick,classKey, id, disabled,data_testid}) => {
    return (
        <motion.button
            // whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            type="button" 
            id= {id ? id : "add_admin"}
            onClick={(e) => handleOnCLick(e)}
            disabled={ disabled || loading}
            className={classKey? classKey :`py-2.5 px-4 rounded-[16px] border border-[#972E4C]  hover:bg-[#AB556E] ${loading ? 'bg-[#777C88]' : 'bg-[#972E4C]' } focus:bg-[#863B50] text-lg disabled:cursor-not-allowed font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf w-full`}
            data-testid={data_testid}
            
        >
            {!loading ? ButtonName : <span>{<Loader />}</span>}
        </motion.button>
    );
}

export default UpdateButton;
